<template>
  <div>
    <div
      v-if="loading"
      class="d-flex w-100 m-3 justify-content-center"
    >
      <v-loader />
    </div>
    <div v-else-if="showClosedPage">
      <div class="row mt-5">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <h3>{{ $t('phrase.research_closed') }}</h3>
              {{ $t('sentence.research_closed') }}
            </div>
          </div>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <div
      v-else
      class="container pt-5 d-flex justify-content-center"
    >
      <div class="card card-body card-message">
        <div v-if="cycles === cyclesLeft">
          <h3>{{researchSet.start_title}}</h3>
          <span v-if="researchSet.start_text">{{researchSet.start_text}}</span>
          <span v-else>{{ $t('sentence.start_reviewing_multiple', {reviewsCount: cycles}) }}</span>
          <div class="mt-3 d-flex justify-content-end">
            <v-button
              text="word.start"
              :route-to="randomResearch"
            />
          </div>
        </div>
        <div v-else>
          <h3>{{ $t('phrase.continue_reviewing') }}</h3>
          {{ $t('sentence.continue_reviewing_multiple') }}
          <div class="mt-3 d-flex justify-content-end">
            <v-button
              text="word.continue"
              :route-to="randomResearch"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Loader from '@/common/components/Loader.vue';
import { fetchExternalParty, fetchResearchSet } from '@/reviewer/api';

export default {
  name: 'ResearchSetReview',
  components: {
    'v-loader': Loader,
    'v-button': Button,
  },
  data() {
    return {
      loading: true,
      researchSet: null,
      showClosedPage: null,
    };
  },
  computed: {
    randomResearch() {
      return {
        name: 'review-research',
        params: {
          uuid: this.researchSet.random_research_uuid,
        },
        query: this.$route.query,
      };
    },
    cycles() {
      return this.researchSet.review_cycles;
    },
    cyclesLeft() {
      return this.researchSet.review_cycles_left;
    },
    researchesLeft() {
      return this.researchSet.researches_left;
    },
    researches() {
      return this.researchSet.researches;
    },
    isActive() {
      return this.researchSet.is_active;
    },
    isClosed() {
      return this.researches === 0 || !this.isActive;
    },
  },
  methods: {
    async initResearchSet() {
      const response = await fetchResearchSet(
        this.$route.params.uuid,
      );
      this.researchSet = response.data;
      if (
        this.isClosed
        || this.researchesLeft === 0
        || this.cyclesLeft === 0
      ) {
        if (this.$route.query.rsid && this.$route.query.uid && this.$route.query.ep) {
          const externalPartyResponse = await fetchExternalParty(
            this.$route.query.ep,
            this.$route.query.rsid,
            this.$route.query.uid,
          );
          const externalParty = externalPartyResponse.data;
          if (externalPartyResponse.status !== 200) {
            // Something went wrong in fetching the external party;
            this.showClosedPage = true;
            this.loading = false;
          } else if (this.researches === 0 && externalParty.closed_redirect_url) {
            // If there are no (active) researches in research set or inactive;
            document.location.href = externalParty.closed_redirect_url;
          } else if (this.researchesLeft === 0 && externalParty.screen_out_redirect_url) {
            // There are no researches left for this user;
            document.location.href = externalParty.screen_out_redirect_url;
          } else {
            // There are no research cycles left (but this should not happen);
            this.showClosedPage = true;
            this.loading = false;
          }
        } else {
          this.showClosedPage = true;
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
  },
  created() {
    this.initResearchSet();
  },
};
</script>


<style>
.card-message {
  max-width: 500px;
}
</style>
